<template>
  <div class="result-image" :style="{ transform: moveParsed }">
    <div
      class="result-image__image"
      :class="{
        'is-active': isActive,
        '-zoom-in': zoomIn,
        '-zoom-in-2': zoomIn2
      }"
      :style="{ backgroundImage: `url(${image})` }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ResultImage",
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    zoomIn: {
      type: Boolean,
      default: false
    },
    zoomIn2: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: require("@/assets/images/gyvunas.jpg"),
      required: false
    },
    move: {
      type: Number,
      default: 0
    }
  },
  computed: {
    moveParsed: function() {
      return `scale(${this.move * 0.0003 + 1})`;
    }
  }
};
</script>

<style lang="scss" scoped>
.result-image {
  display: block;
  height: 100%;
  width: 100%;
  transition: cta-transition(transform, 0.2s);

  &__image {
    $_result-image-transitions: opacity, transform, clip-path;
    background-position: center;
    background-size: cover;
    display: block;
    height: 100%;
    opacity: 0;
    transform: scale(1);
    will-change: $_result-image-transitions;
    transition: cta-transition($_result-image-transitions, 1.2s);
    width: 100%;
    clip-path: ellipse(100% 0% at 50% 0%);

    &.is-active {
      opacity: 1;
      clip-path: ellipse(100% 100% at 50% 50%);
      transition: cta-transition($_result-image-transitions, 1.8s);
    }

    &.-zoom-in {
      transform: translateY(0) scale(1.5);
    }

    &.-zoom-in-2 {
      transform: translateY(0) scale(1.2);
    }
  }
}
</style>
